import { createConfirmation } from 'react-confirm';
import ConfirmDeleteDialog from '../components/confirmDeleteDialog';

// create confirm function
const confirmFunction = createConfirmation(ConfirmDeleteDialog);

// This is optional. But wrapping function makes it easy to use.
export function confirm(confirmation: string, options = {}) {
	options = {
		buttonLabelYes: 'Delete',
		buttonLabelNo: 'Cancel',
		...options
	}
	return confirmFunction({confirmation, options});
}